{
  "brand": {
    "home": "Delve Workshop, dashboard",
    "name": "Workshop"
  },
  "nav": {
    "main": "Workshop",
    "skip": "Skip to content",
    "signOut": "Sign out",
    "signedInAs": "Signed in as admin"
  },
  "loading": "Loading…",
  "checkingSession": "Checking your session…",
  "notFound": {
    "title": "Not found",
    "heading": "No such page",
    "lead": "This page is not part of the workshop.",
    "back": "Back to the dashboard"
  },
  "errors": {
    "unreachable": "The server cannot be reached.",
    "status": "The server answered {{status}}.",
    "generic": "Something went wrong."
  },
  "pager": {
    "page": "Page {{page}} of {{pages}}",
    "previous": "Previous",
    "next": "Next",
    "pages": "Pages"
  },
  "duration": {
    "hours": "{{h}}h {{m}}m",
    "minutes": "{{m}}:{{s}}"
  },
  "units": {
    "B": "B",
    "KB": "KB",
    "MB": "MB",
    "GB": "GB"
  }
}
